class Search_Modal {
	constructor() {
		this.domLoaded = this.domLoaded.bind(this);
		this.isopen = false;
		this.oldfocus = undefined;
		//Check to see if the dom has loaded yet
		if (document.readyState === "loading") {
			//If the dom hasn't loaded, wait until it is
			document.addEventListener("readystatechange", this.domLoaded, {passive: true});
		} else {
			//If it has, run the domLoaded function
			this.domLoaded();
		}
	}

	domLoaded() {
		document.removeEventListener("readystatechange", this.domLoaded);
		this.clickHandeler = this.clickHandeler.bind(this);
		this.keyHandeler = this.keyHandeler.bind(this);

		this.modal = document.querySelector(".modal_canvas");

		document.addEventListener("click", this.clickHandeler);
		document.addEventListener("touchend", this.clickHandeler,{passive: true});
		window.addEventListener("keydown", this.keyHandeler,{passive: true});
	}
	clickHandeler(e) {
		let target = e.target;
		if (target.id === "open_search") {
			e.preventDefault();
			this.open();
		}
		if( target.classList.contains( "modal_canvas" ) || target.classList.contains( "close-modal" )){
			e.preventDefault();
			this.close();
		}
	}
	keyHandeler(e) {
		if (e.code === 'Escape') {
			//27 = escape key
			this.close();
		}
	}
	open(){
		let wrapper = this.modal.querySelector( '.modal_wrapper' );
		this.modal.style.display = "flex";
		this.modal.style.opacity = "0";
		wrapper.style.transform = "translateY( 50px )";
		window.requestAnimationFrame(() => {
			window.requestAnimationFrame(() => {
				this.modal.style.transition = "opacity .3s ease";
				wrapper.style.transition = "transform .3s ease";
				wrapper.style.transform = "none";
				this.modal.style.opacity = 1;
			});
		});
		this.isopen = true;
		this.oldfocus = document.activeElement;

		this.modal.querySelector('input').focus();
	}

	close(){
		let wrapper = this.modal.querySelector( '.modal_wrapper' );
		let modalOldStyles = getComputedStyle( this.modal );
		let wrapperOldStyles = getComputedStyle( wrapper );
		let finish = (e)=>{
			this.modal.style.display = 'none';
			this.modal.querySelector("input").focus();
			wrapper.removeEventListener( 'transitionend', finish );
		}
		window.requestAnimationFrame(() => {
			window.requestAnimationFrame(() => {
				this.modal.style.transition = "opacity .3s ease";
				wrapper.style.transition = "transform .3s ease";
				this.modal.style.opacity = "0";
				wrapper.style.transform = "translateY( 50px )";
				wrapper.addEventListener("transitionend", finish);
			});
		});

		this.isopen = false;
		if (this.oldfocus) {
			this.oldfocus.focus();
			this.oldfocus = undefined;
		}
	}
}

new Search_Modal();

/* Find a railroad */
let find_railroad = Array.from(document.querySelectorAll("[data-open-railroad-finder]"));
if (find_railroad !== null) {
	find_railroad.forEach(link => {
		link.addEventListener("click", async function (e) {
			document.body.style.cursor="wait";
			document.body.style.overflow="hidden";
			e.preventDefault();
			let link = 'wp-admin/admin-ajax.php?action=railroads_search';
			await fetch(link, {cache: "force-cache"})
				.then((response) => {
					if (response.status === 200) {
						document.body.style.cursor="default";
						return response.text();
					}
				}).then(async (html) => {
					let modal = document.querySelector('.railroad_modal_canvas');
					let modalInner = document.querySelector('.railroad_modal_wrapper');
					modalInner.innerHTML = html;
					modal.addEventListener('click', function (e) {
						if (e.target.className === 'close' && e.target.tagName === 'button') {
							e.preventDefault();
							window.requestAnimationFrame(() => {
								modal.style.transition = "opacity .3s ease";
								modalInner.style.transition = "transform .3s ease";
								modal.style.opacity = 0;
								modalInner.style.transform = "translateY( 50px )";
								modal.style.display = "none";
								modalInner.removeAttribute('style');
							});
							window.cancelAnimationFrame(0);
						}
					}, {passive: true});
					// open modal
					modal.style.display = "flex";
					modal.style.opacity = "0";
					modalInner.style.transform = "translateY( 50px )";
					window.requestAnimationFrame(() => {
						modal.style.transition = "opacity .3s ease";
						modalInner.style.transition = "transform .3s ease";
						modalInner.style.transform = "none";
						modal.style.opacity = 1;
					});
					window.cancelAnimationFrame(0);
					let closeModal = modalInner.querySelector('#find-a-railroad-container button.close');
					window.addEventListener('keydown', function (event) {
						if (event.key === 'Escape') {
							modal.style.display = 'none'
							document.body.style.overflow="auto";
						}
					})
					closeModal.addEventListener('click', function (e) {
						e.preventDefault();
						modal.style.display = 'none';
						document.body.style.overflow="auto";
					}, {passive: true});

					// Adds a keyup listener to the datalist input
					fellowship.autocomplete(document.getElementById('search-rr'), "/wp-content/themes/gwrrusa_f21/data/_markers.json");

				})
				.catch((err) => {
					console.log("Find a Railroad modal fetch error", err);
				});
		}, {passive: true});
	});
}

